import PhotoSwipeLightbox from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe-lightbox.esm.min.js';
import PhotoSwipe from 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js';

let lightbox;

function galleryItems() {
  const seen = new Set();
  const items = [];

  document.querySelectorAll('.main-swiper .swiper-slide[data-zoom-src]').forEach((slide) => {
    const id = slide.getAttribute('data-media-id');
    if (!id || seen.has(id)) return;

    seen.add(id);
    items.push({
      src: slide.getAttribute('data-zoom-src'),
      width: Number(slide.getAttribute('data-zoom-width')) || 2400,
      height: Number(slide.getAttribute('data-zoom-height')) || 2400,
      alt: slide.querySelector('img')?.alt || '',
      mediaId: id,
    });
  });

  return items;
}

function backdrop() {
  let el = document.getElementById('product-lightbox-backdrop');
  if (!el) {
    el = document.createElement('div');
    el.id = 'product-lightbox-backdrop';
    document.body.appendChild(el);
  }
  return el;
}

function lockPage() {
  document.documentElement.classList.add('product-lightbox-open');
  backdrop().classList.add('is-visible');
}

function unlockPage() {
  document.documentElement.classList.remove('product-lightbox-open');
  backdrop().classList.remove('is-visible');
}

function getLightbox() {
  if (lightbox) return lightbox;

  lightbox = new PhotoSwipeLightbox({
    dataSource: [],
    pswpModule: PhotoSwipe,
    appendToEl: document.body,
    wheelToZoom: true,
    pinchToClose: false,
    initialZoomLevel: 'fit',
    secondaryZoomLevel: 2,
    maxZoomLevel: 4,
    imageClickAction: 'zoom',
    tapAction: 'zoom',
    doubleTapAction: 'zoom',
    bgOpacity: 1,
    mainClass: 'product-pswp',
  });

  lightbox.on('beforeOpen', lockPage);
  lightbox.on('close', unlockPage);
  lightbox.on('destroy', unlockPage);

  lightbox.init();
  return lightbox;
}

function openLightbox(mediaId) {
  const items = galleryItems();
  if (!items.length) return;

  const index = Math.max(
    0,
    items.findIndex((item) => item.mediaId === mediaId)
  );

  const instance = getLightbox();
  instance.options.dataSource = items;
  instance.loadAndOpen(index);
}

if (!window.productLightboxBound) {
  window.productLightboxBound = true;

  let pointerStartX = 0;

  document.addEventListener('pointerdown', (event) => {
    if (event.target.closest('.main-swiper .swiper-slide')) {
      pointerStartX = event.clientX;
    }
  });

  document.addEventListener('click', (event) => {
    const slide = event.target.closest('.main-swiper .swiper-slide[data-zoom-src]');
    if (!slide || Math.abs(event.clientX - pointerStartX) > 8) return;

    event.preventDefault();
    openLightbox(slide.getAttribute('data-media-id'));
  });
}
